if (!customElements.get('countdown-loader')) {
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.startDate = new Date(this.dataset.startDate).getTime(); // Now
        // console.log("🚀 ~ CountdownTimer ~ constructor ~ startDate:", this.startDate )
        this.endDate = new Date(this.dataset.endDate).getTime();
  
        // console.log('this.endDate :>> ', this.endDate);
        this.totalSeconds = (this.endDate - this.startDate) / 1000;
        // console.log("🚀 ~ CountdownTimer ~ constructor ~ totalSeconds:", this.totalSeconds);
  
    
  
        this.init();
      }
  
      init() {
        this.daysEl = this.querySelector('.day');
        this.hoursEl = this.querySelector('.hour');
        this.minsEl = this.querySelector('.minute');
        this.secsEl = this.querySelector('.second');
        this.progressEl = document.querySelector('.progress');
        this.progressElGlow = document.getElementById('progress-glow')
  
        this.second = 1000;
        this.minute = this.second * 60;
        this.hour = this.minute * 60;
        this.day = this.hour * 24;
  
        this.updateTimer();
        this.interval = setInterval(this.updateTimer.bind(this), this.second);
      }
  
      formatTime(time) {
        return time < 10 ? `0${time}` : time;
      }
  
      updateTimer() {
        const now = new Date();
        let startDate = this.startDate; 
        const timeDiff = this.endDate - now;
  
        if (timeDiff < 0) {
          this.clearTimer();
          return;
        }
  
        const days = Math.floor(timeDiff / this.day);
        const hours = Math.floor((timeDiff % this.day) / this.hour);
        const mins = Math.floor((timeDiff % this.hour) / this.minute);
        const secs = Math.floor((timeDiff % this.minute) / this.second);
  
        this.daysEl.textContent = this.formatTime(days);
        this.hoursEl.textContent = this.formatTime(hours);
        this.minsEl.textContent = this.formatTime(mins);
        this.secsEl.textContent = this.formatTime(secs);
  
        this.updateProgress(now);
      }
  
      updateProgress(currentTime) {
       
        const now = currentTime.getTime(); // Get current time in milliseconds
        let startDate = this.startDate; // Set start date to midnight
        const totalDuration = this.endDate - startDate; // Total countdown duration
       
        const timeRemaining = this.endDate - now; // Time remaining until the countdown ends

      
        // Calculate the percentage of time remaining
        let progress = (timeRemaining / totalDuration) * 100;
      
        // Clamp the progress between 0% and 100%
        progress = Math.max(0, Math.min(progress, 100));

        let progressPercentage = 100 - progress;
      
        // Update the progress bar width
        // this.progressEl.style.width = `${progress}%`;

        // console.log(this.progressEl);

        this.progressEl.style.background = `linear-gradient(to right, transparent ${progressPercentage}%, #ecf0f1 ${progressPercentage}%)`;
        
        if (this.progressElGlow) {
          this.progressElGlow.style.background = `linear-gradient(to right, transparent ${progressPercentage}%, #ecf0f1 ${progressPercentage}%)`;
        }
      }
  
      clearTimer() {
        clearInterval(this.interval);
        this.daysEl.textContent = "00";
        this.hoursEl.textContent = "00";
        this.minsEl.textContent = "00";
        this.secsEl.textContent = "00";
        if (this.progressEl && this.progressEl.style.width) {
          this.progressEl.style.width = '0%';
        } 

        if (this.progressElGlow && this.progressElGlow.style.width) {
          this.progressElGlow.style.width = '0%';
        }

        const progressBar = document.querySelector('.progress-wrapper');
        if (progressBar) {
          progressBar.style.display = 'none';
        }

        const endText = document.querySelector('.countdown-end-text');
        if (endText) {
          endText.style.display = 'block';
        }
      }
    }
  
    customElements.define('countdown-loader', CountdownTimer);
  }
  